/* fb-collection.js — Empire-free collection & search grid controls.
   Empire's StaticCollection/StaticSearch drove: the sort select + its mobile modal,
   the grid/list view toggle, opening the filters panel on mobile, price-range submit,
   the filter-group accordion, blocking disabled (count-0) filter links, and the sticky
   utils-bar shadow. Filter VALUE clicks are plain <a href> links that Empire ALSO
   answered with a full reload (its handler ends in `location.search = …`), so plain
   navigation is exact parity — the desktop AJAX swap is a separate inline script in
   static-collection.liquid and keeps working unchanged.
   Each block wires only if its markup exists (search has no sort/view toggle).
   No-op when Empire is on the page (its script tag carries data-scripts). */
(function () {
  'use strict';
  if (document.querySelector('script[data-scripts]')) return; // Empire owns these controls

  function navigate(mutate) {
    var u = new URL(window.location.href);
    mutate(u.searchParams);
    u.searchParams.delete('page'); // filter/sort changes reset pagination
    var qs = u.searchParams.toString();
    window.location.href = u.pathname + (qs ? '?' + qs : '');
  }

  /* ---- sort: desktop select ---- */
  Array.prototype.forEach.call(document.querySelectorAll('select[data-productgrid-trigger-sort]'), function (sel) {
    sel.addEventListener('change', function () {
      navigate(function (q) { q.set('sort_by', sel.value); });
    });
  });

  /* ---- sort: mobile bottom-sheet ---- */
  var sortModal = document.querySelector('[data-productgrid-sort-content]');
  var sortBtn = document.querySelector('[data-productgrid-modal-sort]');
  function closeSort() {
    if (!sortModal) return;
    sortModal.classList.remove('fb-open');
    sortModal.setAttribute('aria-hidden', 'true');
  }
  if (sortBtn && sortModal) {
    sortBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var open = sortModal.classList.toggle('fb-open');
      sortModal.setAttribute('aria-hidden', open ? 'false' : 'true');
    });
    Array.prototype.forEach.call(sortModal.querySelectorAll('[data-productgrid-trigger-sort-button]'), function (b) {
      b.addEventListener('click', function () {
        navigate(function (q) { q.set('sort_by', b.value); });
      });
    });
    document.addEventListener('click', function (e) {
      if (sortModal.classList.contains('fb-open') && !sortModal.contains(e.target) && e.target !== sortBtn && !sortBtn.contains(e.target)) closeSort();
    });
  }

  /* ---- view toggle (grid ⇄ list), persisted per browser ----
     The view classes MUST go on .productgrid--outer (server renders it with
     productgrid-gridview): every listview rule in theme.css is written as
     `.productgrid-listview .productgrid--items ...` / `.layout--has-sidebar:
     not(.productgrid-listview) ...`, i.e. an ANCESTOR of the items container.
     Toggling them on [data-productgrid-items] itself half-applies list styles
     inside grid cells — squeezed, overflowing cards. */
  var items = document.querySelector('[data-productgrid-items]');
  var outer = document.querySelector('[data-productgrid-outer]') ||
    (items && items.closest && items.closest('.productgrid--outer'));
  var viewButtons = document.querySelectorAll('[data-collection-view]');
  function applyView(view) {
    outer.classList.toggle('productgrid-listview', view === 'list-view');
    outer.classList.toggle('productgrid-gridview', view !== 'list-view');
    Array.prototype.forEach.call(viewButtons, function (b) {
      b.classList.toggle('active', b.getAttribute('data-collection-view') === view);
    });
  }
  if (viewButtons.length && outer) {
    var saved = null;
    try { saved = window.localStorage.getItem('fb-collection-view'); } catch (e) {}
    if (saved === 'list-view') applyView(saved);
    Array.prototype.forEach.call(viewButtons, function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-collection-view');
        try { window.localStorage.setItem('fb-collection-view', v); } catch (e) {}
        applyView(v);
      });
    });
  }

  /* ---- filter-group accordion — server renders every group OPEN (the CSS only hides
     [data-accordion-content] once Empire stamps data-accordion-state on it), which
     matches the live "expand_all" setting; the heading button collapses/expands ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-filter-group-trigger]') : null;
    if (!t) return;
    e.preventDefault();
    var group = t.closest('[data-filter-group]');
    var content = group && group.querySelector('[data-accordion-content]');
    if (!content) return;
    var isClosed = content.style.display === 'none';
    content.style.display = isClosed ? '' : 'none';
    t.setAttribute('aria-expanded', isClosed ? 'true' : 'false');
    group.classList.toggle('fb-collapsed', !isClosed);
  });

  /* ---- filter values with 0 results must not navigate ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[data-filter-input][data-disabled]') : null;
    if (a) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* ---- price range → navigate with filter.v.price.* merged into the current URL ---- */
  Array.prototype.forEach.call(document.querySelectorAll('.collection-filters__price-range-form'), function (form) {
    function submit() {
      navigate(function (q) {
        Array.prototype.forEach.call(form.querySelectorAll('[data-filter-range]'), function (inp) {
          if (inp.value !== '') q.set(inp.name, inp.value);
          else q.delete(inp.name);
        });
      });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    Array.prototype.forEach.call(form.querySelectorAll('[data-filter-range]'), function (inp) {
      inp.addEventListener('change', submit);
    });
  });

  /* ---- mobile filters: off-canvas panel (own implementation — Empire's jQuery modal
     is gone with the bundle). Styles in fb-sections.css under html.fb-mf-open. ---- */
  var sidebar = document.querySelector('[data-productgrid-sidebar]');
  var trigger = document.querySelector('[data-productgrid-trigger-filters]');
  if (sidebar && trigger) {
    var scrim = document.createElement('div');
    scrim.className = 'fb-mf-scrim';
    scrim.hidden = true;
    document.body.appendChild(scrim);
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'fb-mf-close';
    closeBtn.innerHTML = '<span>Listo</span><svg viewBox="0 0 20 20" width="15" height="15" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
    sidebar.insertBefore(closeBtn, sidebar.firstChild);
    var setMF = function (open) {
      document.documentElement.classList.toggle('fb-mf-open', open);
      scrim.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    trigger.addEventListener('click', function (e) { e.preventDefault(); setMF(true); });
    scrim.addEventListener('click', function () { setMF(false); });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.fb-mf-close')) setMF(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { setMF(false); closeSort(); }
    });
  }

  /* ---- sticky utils bar: position:sticky is pure CSS; Empire only added the shadow ---- */
  var utils = document.querySelector('.productgrid--utils-sticky');
  var sentinel = document.querySelector('[data-utils-intersection-target]');
  if (utils && sentinel && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      utils.classList.toggle('productgrid--utils-box-shadow', !entries[0].isIntersecting);
    }).observe(sentinel);
  }
})();
